import { Theme } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

export default function Radio(theme: Theme, containerId: string) {
  return {
    MuiRadio: {
      defaultProps: {
        container: document.getElementById(containerId),
        color: 'primary',
      },
      styleOverrides: {
        root: {
          padding: theme.spacing(1),
        },
      },
    },
  };
}
